import {
  createStore,
  Plugin,
  PluginFunctions,
  SpecialZoomLevel,
} from "@react-pdf-viewer/core";
import * as React from "react";

interface CustomZoomPlugin extends Plugin {
  zoomTo(scale: number | SpecialZoomLevel): void;
}
export interface StoreProps {
  zoom?(scale: number | SpecialZoomLevel): void;
}
const useZoomPlugin = (): CustomZoomPlugin => {
  const store = React.useMemo(() => createStore<StoreProps>({}), []);

  return {
    install: (pluginFunctions: PluginFunctions) => {
      store.update("zoom", pluginFunctions.zoom);
    },
    zoomTo: (scale: number | SpecialZoomLevel) => {
      const zoom = store.get("zoom");
      if (zoom) {
        // Zoom to that scale
        zoom(scale);
      }
    },
  };
};

export default useZoomPlugin;
